import { render, staticRenderFns } from "./ReportStatusManageWidget.vue?vue&type=template&id=53fead9f&scoped=true&"
import script from "./ReportStatusManageWidget.vue?vue&type=script&lang=js&"
export * from "./ReportStatusManageWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportStatusManageWidget.vue?vue&type=style&index=0&id=53fead9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fead9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53fead9f')) {
      api.createRecord('53fead9f', component.options)
    } else {
      api.reload('53fead9f', component.options)
    }
    module.hot.accept("./ReportStatusManageWidget.vue?vue&type=template&id=53fead9f&scoped=true&", function () {
      api.rerender('53fead9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportStatusManageWidget.vue"
export default component.exports